// wp-icons — Layout & View (10)
import { createWpIcon } from './createIcon.js';

export const LayoutDashboard = createWpIcon('LayoutDashboard', [
  ['rect', { width: 7, height: 9, x: 3, y: 3, rx: 1, key: 'a' }],
  ['rect', { width: 7, height: 5, x: 14, y: 3, rx: 1, key: 'b' }],
  ['rect', { width: 7, height: 9, x: 14, y: 12, rx: 1, key: 'c' }],
  ['rect', { width: 7, height: 5, x: 3, y: 16, rx: 1, key: 'd' }],
]);
export const LayoutGrid = createWpIcon('LayoutGrid', [
  ['rect', { width: 7, height: 7, x: 3, y: 3, rx: 1, key: 'a' }],
  ['rect', { width: 7, height: 7, x: 14, y: 3, rx: 1, key: 'b' }],
  ['rect', { width: 7, height: 7, x: 14, y: 14, rx: 1, key: 'c' }],
  ['rect', { width: 7, height: 7, x: 3, y: 14, rx: 1, key: 'd' }],
]);
export const List = createWpIcon('List', [
  ['line', { x1: 8, x2: 21, y1: 6, y2: 6, key: 'a' }],
  ['line', { x1: 8, x2: 21, y1: 12, y2: 12, key: 'b' }],
  ['line', { x1: 8, x2: 21, y1: 18, y2: 18, key: 'c' }],
  ['line', { x1: 3, x2: 3.01, y1: 6, y2: 6, key: 'd' }],
  ['line', { x1: 3, x2: 3.01, y1: 12, y2: 12, key: 'e' }],
  ['line', { x1: 3, x2: 3.01, y1: 18, y2: 18, key: 'f' }],
]);
export const Menu = createWpIcon('Menu', [
  ['line', { x1: 4, x2: 20, y1: 12, y2: 12, key: 'a' }],
  ['line', { x1: 4, x2: 20, y1: 6, y2: 6, key: 'b' }],
  ['line', { x1: 4, x2: 20, y1: 18, y2: 18, key: 'c' }],
]);
export const MoreHorizontal = createWpIcon('MoreHorizontal', [
  ['circle', { cx: 12, cy: 12, r: 1, key: 'a' }],
  ['circle', { cx: 19, cy: 12, r: 1, key: 'b' }],
  ['circle', { cx: 5, cy: 12, r: 1, key: 'c' }],
]);
export const MoreVertical = createWpIcon('MoreVertical', [
  ['circle', { cx: 12, cy: 12, r: 1, key: 'a' }],
  ['circle', { cx: 12, cy: 5, r: 1, key: 'b' }],
  ['circle', { cx: 12, cy: 19, r: 1, key: 'c' }],
]);
export const Filter = createWpIcon('Filter', [
  ['polygon', { points: '22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3', key: 'a' }],
]);
export const Search = createWpIcon('Search', [
  ['circle', { cx: 11, cy: 11, r: 8, key: 'a' }],
  ['path', { d: 'm21 21-4.3-4.3', key: 'b' }],
]);
export const Eye = createWpIcon('Eye', [
  ['path', { d: 'M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z', key: 'a' }],
  ['circle', { cx: 12, cy: 12, r: 3, key: 'b' }],
]);
export const EyeOff = createWpIcon('EyeOff', [
  ['path', { d: 'M9.88 9.88a3 3 0 1 0 4.24 4.24', key: 'a' }],
  ['path', { d: 'M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68', key: 'b' }],
  ['path', { d: 'M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61', key: 'c' }],
  ['line', { x1: 2, x2: 22, y1: 2, y2: 22, key: 'd' }],
]);
